module.exports = __webpack_public_path__ + "static/img/17.42a4b68.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/sp/17.png
// module id = s1mD
// module chunks = 0